export default __webpack_public_path__ + "static/media/Yulchik_bb.5198b75c.png";